const MAINTENANCE_AGENT_OCTANE_FLAG = 'maintenance-agent-octane';
function resolveMaintenanceAgentUrl(backend, hostedUrl, octaneUrl) {
  if (backend === 'octane' && !octaneUrl) {
    throw new Error('NEXT_PUBLIC_OCTANE_MAINTENANCE_AGENT_URL is required when maintenance-agent-octane is on');
  }
  return backend === 'octane' ? octaneUrl : hostedUrl;
}

export { MAINTENANCE_AGENT_OCTANE_FLAG, resolveMaintenanceAgentUrl };
